import { useContext } from 'react'

import { FrameBuilderStringsContext } from '@frame-builder/contexts/strings-context'

import RangeSlider from '@components/range-slider'

interface PassepartoutColorDetailsProps {
  width: number
  height: number
  min: number
  max: number
  setWidth: (newValue: number) => void
  setHeight: (newValue: number) => void
  onWidthChange?: (value: number) => void
  onHeightChange?: (value: number) => void
}

const PassepartoutSizeControls = ({
  width,
  height,
  min,
  max,
  setWidth,
  setHeight,
  onWidthChange,
  onHeightChange,
}: PassepartoutColorDetailsProps) => {
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)

  return (
    <div className="space-y-1">
      <span className="font-medium">
        {frameBuilderStrings.passepartoutSizeLabel}
      </span>

      <div className="space-y-2">
        <RangeSlider
          label={frameBuilderStrings.passepartoutWidthLabel}
          value={width}
          setValue={setWidth}
          onChange={onWidthChange}
          min={min}
          max={max}
        />

        <RangeSlider
          label={frameBuilderStrings.passepartoutHeightLabel}
          value={height}
          setValue={setHeight}
          onChange={onHeightChange}
          min={min}
          max={max}
        />
      </div>
    </div>
  )
}

export default PassepartoutSizeControls
